import { useEffect, useState } from "react";

import { notebookService } from "../../../../../App";
import { SearchNoteResponse } from "../../../../../model/models";
import './GlobalSearchNotes.css';
//import NoteCardMinimal from "./NoteCardMinimal";
//import NoteCardSoft from "./NoteCardSoft";
//import NoteCard from "./NoteCard";
import NoteCardFloating from "./NoteCardFloating";
import LTSearchBox from "../../../../common/LTSearchBox";

const GlobalSearchNotes = () => {
  const [latestNotes, setLatestNotes] = useState([] as SearchNoteResponse[]);
  const [searchText, setSearchText] = useState("");
  
  const handleSearch = async () => {
    const result = await notebookService.searchNotesByQuery(searchText);
    setLatestNotes(mapPreviewData(result));
  };

  // just for the first load
  useEffect(() => {
    const fetchData = async () => {
      const result = await notebookService.readLatestNotesByOwner();
      setLatestNotes(mapPreviewData(result));
    };
    fetchData();
  }, []);

  const mapPreviewData = (data: SearchNoteResponse[]) => {
    if(!data){
      return [];
    }
    return data.map((note) => {
      return {...note}
    });
  };

  return (
    <div className="global-search__wrapper-container">
      <div className="global-search__header">
        <div className="global-search__container">
          <div className="global-search__wrapper">
          <LTSearchBox
            value={searchText}
            placeholder="Search notes..."
            maxLength={30}
            onChange={setSearchText}
            onSearch={handleSearch}
            autoSearch={true}
            ariaLabel="Search notes"
          />
        </div>
        </div>
      </div>

      <div className="global-search__results">
        <div className="global-search__grid">
          {latestNotes.map((note, index) => {
            return <NoteCardFloating key={index} note={note} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default GlobalSearchNotes;
